<template>
    <div class="main">
        <form-aee :paramId="$route.params.id" v-on:onSubmit="onSubmit"></form-aee>
    </div>
</template>

<script>
import formAee from './form'

export default {
    methods: {
        onSubmit () {
            this.$router.push('/admin/pedagogico/aee')
        }
    },
    components: { formAee }
}
</script>
